module.exports = __webpack_public_path__ + "public/images/Illustration_Languages_200x174.d4d16ef44f1c21ae6bd40995961afb17.png";